<p>error-closed works!</p>
